exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".device-pairing-modal__container{width:1060px;width:66.25rem}@media (max-width:1060px){.device-pairing-modal__container{width:inherit}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e01944d6","scoped":false,"hasInlineConfig":false}!./~/postcss-loader!./~/sass-loader/lib/loader.js!./app/components/device-pairing-modal/style.scss
// module id = 266
// module chunks = 0